/**
 * Devportal-Track: Feature-Flag + Rollen-Matrix (Spec 247 §4.1/§4.3).
 *
 * Owned Path des Devportal-Tracks (docs/SCOPE-DEVPORTAL-TRACK.md §2).
 * Bewusst KEINE Erweiterung von ROLE_GROUPS (types/auth.ts) oder FEATURES
 * (lib/utils/constants.ts) — beides Core-Dateien ausserhalb der
 * Mount-Point-Tabelle (Spec 247 §5).
 */
import type { UserRole } from '@/types/auth';
import { PLATFORM_ROLES } from '@/types/auth';

/**
 * Sichtbarkeits-Matrix Spec 247 §4.1 (Owner-Entscheidung 2026-06-10):
 * merchant_product_manager + merchant_it ja, merchant_viewer nein,
 * alle Plattform-Rollen ja.
 */
export const DEVPORTAL_ROLES: UserRole[] = [
  ...PLATFORM_ROLES,
  'merchant_product_manager',
  'merchant_it',
];

/**
 * Feature-Flag `devportal` (Spec 247 §4.3) — default aus.
 * Steuert Sidebar-Eintrag UND Routen-Registrierung; Stage-Rollout via
 * VITE_ENABLE_DEVPORTAL in frontend/.env.{stage} (deploy-generiert,
 * Aktivierung pro Stage = Core-Mini-PR, siehe Plan §Koordination).
 */
export function isDevportalEnabled(): boolean {
  return import.meta.env.VITE_ENABLE_DEVPORTAL === 'true';
}

/**
 * Credentials-Seite (Spec 279 §4.1) — Abweichung von DEVPORTAL_ROLES:
 * BEWUSST keine Plattform-Rollen (kein Merchant-Kontext, Spec 279 §4.1.1).
 * Read = Key-Liste (nie Secrets), Write = Create/Revoke/Rotate.
 * Backend-Gegenstuecke: src/services/devportal/devportal-roles.ts —
 * beide Seiten per Literal-Pin-Test deckungsgleich gehalten.
 */
export const DEVPORTAL_CREDENTIALS_READ_ROLES: UserRole[] = [
  'merchant_it',
  'merchant_product_manager',
];

export const DEVPORTAL_CREDENTIALS_WRITE_ROLES: UserRole[] = ['merchant_it'];

/**
 * Ein-Klick-Test-TX (Spec 279 §5.5): Trigger nur merchant_it — Spiegel der
 * Core-Permission `transactions:trigger:own` (Spec 0042); Plattform-Rollen
 * nutzen das Panel-Werkzeug /transactions/trigger (Spec 279 §4.1.1).
 * Serverseitig sichert der bestehende BFF-403 des Core-Endpoints.
 */
export const DEVPORTAL_TX_TRIGGER_ROLES: UserRole[] = ['merchant_it'];

/**
 * Sandbox-Provisioning-Seite (Spec 328 §7) — Abweichung von DEVPORTAL_ROLES wie
 * bei den Credentials: BEWUSST keine Plattform-Rollen (kein Merchant-Kontext).
 * Read = Status-Sicht der 3 Sandbox-Services, Write = (Re-)Provision/Offboard.
 * Backend-Gegenstuecke: src/services/devportal/devportal-roles.ts —
 * beide Seiten per Literal-Pin-Test deckungsgleich gehalten.
 */
export const DEVPORTAL_PROVISIONING_READ_ROLES: UserRole[] = [
  'merchant_it',
  'merchant_product_manager',
];

export const DEVPORTAL_PROVISIONING_WRITE_ROLES: UserRole[] = ['merchant_it'];
